export const API_HOST_WMS = "baseUrl";
export const API_HOST_POD = "podBaseUrl";
export const API_HOST_HP = "hpBaseUrl";

const config = {
  development: {
    [API_HOST_POD]: "https://devpod.hyperpure.com/",
    [API_HOST_WMS]: "https://hpadminpod.zomans.com/",
    [API_HOST_HP]: "https://dev.hyperpure.com/",
  },
  staging: {
    [API_HOST_POD]: "https://devpod.hyperpure.com/",
    [API_HOST_WMS]: "https://hpadminpod.zomans.com/",
    [API_HOST_HP]: "https://hyperpure.com/",
  },
  production: {
    [API_HOST_POD]: "https://pod.hyperpure.com",
    [API_HOST_WMS]: "https://prodhpadmin.zomans.com/",
    [API_HOST_HP]: "https://hyperpure.com",
  },
};

let apiEndpoint = "";
if (process.env.REACT_APP_API_ENDPOINT) {
  apiEndpoint = config[process.env.REACT_APP_API_ENDPOINT];
} else {
  apiEndpoint = config[process.env.NODE_ENV];
}

export default apiEndpoint;
